// noinspection JSUnusedGlobalSymbols imported via d.ts file
import {createModalV2} from "../../../../../helpers/modals/modalV2";
import {clearFeedbacksByName, fillInputsByName} from "../../../../../helpers/forms";
import {setAsDateField} from "../../../../../helpers/inputs";
import {syncInputValue} from "../../../../../helpers/inputs/syncInputs/syncInputValue";
import moment from "moment";
import {displayLocalValidationError} from "../../../../../helpers/forms/validationErrors/utils";

// noinspection JSUnusedGlobalSymbols -- imported via d.ts
/**
 * @param {GanttWrapper.GanttWrapper} gantt
 * @return {WorkableDaysModal.WorkableDaysModal}
 */
function createWorkableDaysModal(gantt) {
	/** @type {TimelineSettingsDefs.Settings} */
	let settings;

	// noinspection DuplicatedCode,JSCheckFunctionSignatures
	const modal = createModalV2({
		// There should be only one instance of this modal on the DOM
		modalContainer: document.querySelector('.timeline-workable-days-modal'),
		init() {
			// Setup events
			this.modalContainer.querySelector('.add-exception-button')
				.addEventListener('click', () => {
					addException();
				})

			// Setup confirm button
			this.modalContainer.querySelector('.timeline-workable-days-modal-confirm-button')
				.addEventListener('click', () => {
					handleSuccess();
				})

		}
	});

	// Override display function to setup on display
	modal._og_display = modal.display;

	modal.display = (firstTime = true) => {
		// Copy current settings from gantt so we operate on a local copy
		// for the modal
		settings = {
			workableDays: {
				...gantt._settings.workableDays
			},
			workableDaysExceptions: gantt._settings.workableDaysExceptions.map(exception => {
				return {
					...exception,
				}
			})
		}

		renderModal();

		modal._og_display(firstTime);
	}

	// Get templates
	const exceptionContainerTemplate = modal.modalContainer.querySelector('.templates .exception-container');


	// noinspection JSValidateTypes
	return modal;

	// Methods

	function addException() {
		settings.workableDaysExceptions.push({
			description: '',
			admin_description: '',
			start: moment(),
			end: null,
		})

		renderExceptions();
	}

	function renderExceptions() {
		const exceptionsWrapper = modal.modalContainer.querySelector('.exceptions-container-wrapper');
		const exceptionsContainer = exceptionsWrapper.querySelector('.exceptions-container');
		const emptyMessage = exceptionsWrapper.querySelector('.empty-message');

		// Clear DOM
		exceptionsContainer.innerHTML = '';

		// Display or hide empty list message
		if (settings.workableDaysExceptions.length === 0) {
			emptyMessage.classList.remove('d-none');
		} else {
			emptyMessage.classList.add('d-none');
		}

		// Render exceptions
		settings.workableDaysExceptions.forEach((exception, index) => {
			/**
			 * @type {HTMLElement}
			 */
			const containerElement = exceptionContainerTemplate.cloneNode(true);

			containerElement.dataset.exceptionIndex = index.toString();

			// Fill description
			fillInputsByName(containerElement, {
				...exception,
			})

			// Initialize date pickers
			const startDateField = containerElement.querySelector('input[name="start"]');
			const endDateField = containerElement.querySelector('input[name="end"]');

			setAsDateField(startDateField, {
				date: exception.start,
				widgetPositioning: {
					horizontal: 'right',
				},
			});
			setAsDateField(endDateField, {
				date: exception.end,
				widgetPositioning: {
					horizontal: 'right',
				},
				wrapperSettings: {
					showClearButton: true,
				}
			});

			// Setup delete button
			containerElement.querySelector('.delete-exception-button')
				.addEventListener('click', () => {
					const index = settings.workableDaysExceptions.indexOf(exception);

					// Remove exception from local array
					settings.workableDaysExceptions.splice(index, 1);

					// Refresh list
					renderExceptions();
				})

			// Sync inputs
			syncInputValue(
				exception,
				containerElement.querySelector('input[name="description"]'),
				'description'
			);

			$(startDateField).on('dp.change', () => {
				exception.start = $(startDateField).data("DateTimePicker").date();
			})

			$(endDateField).on('dp.change', () => {
				exception.end = $(endDateField).data("DateTimePicker").date();
			})

			exceptionsContainer.appendChild(containerElement);
		})
	}

	function renderModal() {
		// Fill workweek from gantt
		const workableDays = settings.workableDays;
		Object.keys(workableDays).forEach(key => {
			modal.modalContainer.querySelector(`input[name="${key}"]`).checked = workableDays[key];
		})

		renderExceptions();
	}

	function handleSuccess() {
		// Make sure we should be able to save this
		if (validateSettings() === false) {
			return;
		}

		const workableDays = settings.workableDays;

		// Update gantt properties from modal
		Object.keys(workableDays).forEach(key => {
			workableDays[key] = modal.modalContainer.querySelector(`input[name="${key}"]`).checked;
		})

		// Clean up workable day exceptions
		settings.workableDaysExceptions.forEach(exception => {
			// If saving a exception range
			if (exception.end) {
				if (exception.start.isSame(exception.end, 'day')) {
					// Same day range, make a single day exception
					exception.end = null;
				} else if (exception.start.isAfter(exception.end)) {
					// Swap dates to make sense
					const tempDate = exception.start;
					exception.start = exception.end;
					exception.end = tempDate;
				}
			}
		})

		// Update gantt settings from local copy
		gantt._settings.workableDays = settings.workableDays;
		gantt._settings.workableDaysExceptions = settings.workableDaysExceptions;

		modal.hide();

		// Notify gantt to refresh view
		modal.notifySuccessListeners();
	}

	function validateSettings() {
		clearFeedbacksByName(modal.modalContainer);

		// Validate that at least 1 day of the week can be worked
		const workableDays = gantt._settings.workableDays;

		let workableDay = false;

		// Check properties from modal DOM
		Object.keys(workableDays).forEach(key => {
			if (modal.modalContainer.querySelector(`input[name="${key}"]`).checked) {
				workableDay = true;
			}
		})

		if (workableDay === false) {
			alert('At least 1 day of the week must be workable');
			return false;
		}

		// Check exceptions
		for (const exception of settings.workableDaysExceptions) {
			const index = settings.workableDaysExceptions.indexOf(exception);
			const exceptionContainer = modal.modalContainer
				.querySelector(`.exception-container[data-exception-index="${index}"]`);
			if (exception.description.trim() === '') {
				displayLocalValidationError(exceptionContainer, 'description', 'Exception requires a reason');

				// Reject empty exception
				return false;
			}
			if (exception.description.length > 800) {
				displayLocalValidationError(exceptionContainer, 'description', 'Exception reason must be less than 800 chars');

				return false;
			}
		}

		return true;
	}
}

export {createWorkableDaysModal}
